export default __webpack_public_path__ + "static/media/business_show_3_en.75f12e3f.png";